import React from "react";
import { StyledTabPanel } from "./TabPanel.styled";
import { Box } from "@mui/material";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <StyledTabPanel sx={{ p: 1 }}>{children}</StyledTabPanel>
      )}
    </div>
  );
};

export default TabPanel;
